import { render } from "./dappBadge.vue?vue&type=template&id=f6bbb394"
import script from "./dappBadge.vue?vue&type=script&lang=js"
export * from "./dappBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__